module.exports = __webpack_public_path__ + "img/577.8949d568.png";